"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ConfigContext", {
  enumerable: true,
  get: function get() {
    return _ConfigContext.ConfigContext;
  }
});
exports.fetchPhrases = exports.contentTypeMapping = void 0;
exports.filterReplyForBulkAction = filterReplyForBulkAction;
exports.filterSelectedReplies = filterSelectedReplies;
exports.getAllVisibleReplies = getAllVisibleReplies;
exports.getCategory = getCategory;
exports.getFormattedContent = getFormattedContent;
exports.getFormattedPollData = getFormattedPollData;
exports.getFormattedTitle = getFormattedTitle;
exports.getFormattedVotesData = getFormattedVotesData;
exports.getPostIdFromURL = getPostIdFromURL;
exports.getRepliesPaginationParamsFromURL = getRepliesPaginationParamsFromURL;
exports.normalizeAuthor = void 0;
exports.scrollToCssSelector = scrollToCssSelector;
exports.setRepliesPaginationParams = setRepliesPaginationParams;
exports.showEscalateButton = showEscalateButton;
exports.toggleReplyOnTrash = toggleReplyOnTrash;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _zip = require("@insided/shared/utils/zip");

var _phrase = require("@insided/deprecated-libs/translationsUtils/phrase");

var _ConfigContext = require("@insided/shared/services/ConfigContext");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function showEscalateButton(escalateTopic, escalateReply, isReply, hasUrl, contentType) {
  if (hasUrl) {
    return false;
  }

  if (isReply) {
    return true; // TODO: replace return when new topic moderation page is used for all content types
    // return escalateReply
  }

  return !(contentType === 'article' || contentType === 'productUpdate'); // TODO: replace return when new topic moderation page is used for all content types
  // return escalateTopic
}

function getFormattedTitle() {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var isReply = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var formattedTitle = isReply ? "RE: ".concat(title !== null && title !== void 0 ? title : '') : title;
  return formattedTitle.length > 150 ? formattedTitle.slice(0, 147) + '...' : formattedTitle;
}

function getFormattedContent(contentType, destinationUrl, topicId, content) {
  var formattedContentType = contentTypeMapping[contentType];
  var url = destinationUrl;

  if (['productUpdate', 'idea'].includes(contentType)) {
    url = "".concat(destinationUrl).concat(formattedContentType, "/").concat(topicId);
  }

  return "".concat(content !== null && content !== void 0 ? content : '', " \n \n------------------\n").concat(url, " ");
}

function getAllVisibleReplies(replies) {
  var filteredReplies = replies.result.filter(function (reply) {
    return !reply.trashed && !reply.spam;
  });
  return filteredReplies.map(function (reply) {
    return reply.id;
  });
}

function getFormattedPollData(options, votes) {
  var votesTotal = votes.reduce(function (a, b) {
    return a + b;
  }, 0);
  var zippedData = (0, _zip.zip)(options, votes);
  return Object.values(zippedData).map(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        option = _ref2[0],
        vote = _ref2[1];

    return {
      option: option,
      vote: vote,
      percentage: isNaN(vote / votesTotal * 100) ? 0 : Number((vote / votesTotal * 100).toFixed())
    };
  });
}

function getFormattedVotesData(votes) {
  return {
    options: Object.keys(votes),
    voteCount: Object.values(votes)
  };
}

function filterSelectedReplies(replies, selectedReplyId) {
  if (selectedReplyId === undefined) return [];
  return replies.filter(function (id) {
    return selectedReplyId !== id;
  });
}

function filterReplyForBulkAction(contentType, replies) {
  return {
    result: replies.result.map(function (reply) {
      return _objectSpread(_objectSpread({}, reply), {}, {
        contentType: contentType,
        replyId: reply.id
      });
    }),
    metadata: replies.metadata
  };
}

function scrollToCssSelector(selector) {
  var _document$querySelect, _document$querySelect2, _document$querySelect3;

  var offset = window.scrollY + ((_document$querySelect = (_document$querySelect2 = document.querySelector(selector)) === null || _document$querySelect2 === void 0 ? void 0 : (_document$querySelect3 = _document$querySelect2.getBoundingClientRect()) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.top) !== null && _document$querySelect !== void 0 ? _document$querySelect : 0);
  window.scrollTo({
    behavior: 'smooth',
    top: offset
  });
}

function toggleReplyOnTrash(replies, replyId) {
  return {
    result: replies.result.map(function (reply) {
      if (reply.id === replyId) {
        return _objectSpread(_objectSpread({}, reply), {}, {
          trashed: !reply.trashed
        });
      }

      return reply;
    }),
    metadata: replies.metadata
  };
}

function getRepliesPaginationParamsFromURL() {
  var searchParams = new URLSearchParams(window.location.search);
  var page = searchParams.has('page') ? Number(searchParams.get('page')) : undefined;
  var pageSize = searchParams.has('size') ? Number(searchParams.get('size')) : undefined;
  return {
    page: page,
    pageSize: pageSize
  };
}

function setRepliesPaginationParams(query) {
  var page = query.page,
      pageSize = query.pageSize;
  var searchParams = new URLSearchParams(window.location.search);
  if (!page && !pageSize) return;

  if (page) {
    searchParams.set('page', String(page));
  }

  if (pageSize) {
    searchParams.set('size', String(pageSize));
  }

  var newURL = window.location.pathname + '?' + searchParams.toString() + window.location.hash;
  history.replaceState(null, '', newURL);
}

function getPostIdFromURL() {
  var _ref3;

  var locationHash = window.location.hash;
  var anchorPostId = locationHash.slice(locationHash.indexOf('/') + 1);
  var searchParams = new URLSearchParams(window.location.search);
  var postidParams = searchParams.has('postid') ? searchParams.get('postid') : undefined;
  return (_ref3 = postidParams !== null && postidParams !== void 0 ? postidParams : anchorPostId) !== null && _ref3 !== void 0 ? _ref3 : undefined;
}

var contentTypeMapping = {
  discussion: 'conversations',
  productUpdate: 'product-updates',
  idea: 'ideas',
  question: 'questions',
  article: 'articles',
  conversation: 'conversations'
};
exports.contentTypeMapping = contentTypeMapping;

var normalizeAuthor = function normalizeAuthor(author) {
  return _objectSpread(_objectSpread({}, author), {}, {
    signature: author.signature === '' ? null : author.signature,
    customTitle: author.customTitle === '' ? null : author.customTitle,
    reputation: _objectSpread(_objectSpread({}, author.reputation), {}, {
      rank: author.reputation.rank === '' ? null : author.reputation.rank,
      rankIcon: author.reputation.rankIcon === '' ? null : author.reputation.rankIcon,
      rankIconThumbnail: author.reputation.rankIconThumbnail === '' ? null : author.reputation.rankIconThumbnail
    })
  });
};

exports.normalizeAuthor = normalizeAuthor;

function getCategory(categories, id) {
  if (!id) return null;

  var _iterator = _createForOfIteratorHelper(categories),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var category = _step.value;

      if (category.id === id) {
        return category;
      }

      if (category.children) {
        var foundCategory = getCategory(category.children, id);

        if (foundCategory) {
          return foundCategory;
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return null;
}

var fetchPhrases = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(phrasesSet) {
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Promise.all(phrasesSet.map( /*#__PURE__*/function () {
              var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(p) {
                return _regenerator.default.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return new Promise(function (resolve) {
                          return (0, _phrase.fetchPhrase)(p.module, p.key, function (phrs) {
                            return resolve(phrs);
                          });
                        });

                      case 2:
                        return _context.abrupt("return", _context.sent);

                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x2) {
                return _ref5.apply(this, arguments);
              };
            }()));

          case 2:
            return _context2.abrupt("return", _context2.sent);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchPhrases(_x) {
    return _ref4.apply(this, arguments);
  };
}();

exports.fetchPhrases = fetchPhrases;